import handleError from "./handle-error";
import api from "../api";
import axios from "../utils/axios.instance";
import store from "@store/index";
import { loginUser, setUserData } from "@store/actions/auth.action";

// export const login = async (payload) => {
//   try {
//     const { data } = await axios.post(api.login, payload);
//     // in your login action after successful response
//       localStorage.setItem("accessToken", data.token);
//       localStorage.setItem("refreshToken", data.refreshToken);
//       localStorage.setItem("sessionId", data.sessionId);
//     return data;
//   } catch (err) {
//     return handleError(err);
//   }
// };

export const login = async (payload) => {
  try {
    const { data } = await axios.post(api.login, payload);

    console.log("🔍 Login response:", data);

    // ✅ CORRECT: Access the nested data
    if (data.success && data.data) {
      const { sessionId, token, refreshToken } = data.data;

      console.log("✅ Extracted sessionId:", sessionId);
      console.log("✅ Extracted token:", token);

      if (payload?.skipLocalStorage) {
        // Store in localStorage
        localStorage.setItem("accessToken", token);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("sessionId", sessionId);
      }

      console.log(
        "✅ Stored sessionId in localStorage:",
        localStorage.getItem("sessionId"),
      );

      return data; // Return the nested data object
    } else {
      throw new Error("Login failed: " + (data.message || "Unknown error"));
    }
  } catch (err) {
    console.error("Login error:", err);
    return handleError(err);
  }
};

export const logoutApi = async (payload) => {
  try {
    const { data } = await axios.patch(api.logout, payload);
    return data;
  } catch (err) {
    console.error("Logout error:", err);
    return handleError(err);
  }
};

const storeAuthSession = (session) => {
  const { sessionId, token, refreshToken } = session || {};
  if (token) {
    localStorage.setItem("accessToken", token);
  }
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  }
  if (sessionId) {
    localStorage.setItem("sessionId", sessionId);
  }
};

export const getMicrosoftLoginUrl = async (userType, email, prompt) => {
  try {
    const params = {};
    if (userType) params.userType = userType;
    if (email) params.login_hint = email;
    if (prompt) params.prompt = prompt;
    const { data } = await axios.get(api.microsoftLoginUrl, { params });
    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const loginWithMicrosoft = async ({ code, state }) => {
  try {
    const { data } = await axios.post(api.microsoftLogin, { code, state });

    if (data.success && data.data) {
      storeAuthSession(data.data);
      return data;
    }

    throw new Error(
      "Microsoft login failed: " + (data.message || "Unknown error"),
    );
  } catch (err) {
    return handleError(err);
  }
};

export const resendOtpVerifyEmail = async (email) => {
  try {
    const { data } = await axios.get(api.resendOtpverifyEmail + `/${email}`);

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const verifyEmail = async (payload) => {
  try {
    const { data } = await axios.post(api.verifyEmail, payload);

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const registerEmailVerify = async (payload) => {
  try {
    const { data } = await axios.post(api.registerEmailVerify, payload);

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const signup = async (params) => {
  try {
    const { data } = await axios.post(api.signup, params);
    if (data.success) return data;
    return false;
  } catch (err) {
    return handleError(err);
  }
};

export const createRecruiterProfile = async (params, token) => {
  try {
    const { data } = await axios.post(api.createRecruiterProfile, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (data.success) return data;
    return false;
  } catch (err) {
    return handleError(err);
  }
};

// In auth.service.js - update refreshTokenService
export const refreshTokenService = async (refreshToken) => {
  try {
    const sessionId = localStorage.getItem("sessionId");
    const res = await axios.post(api.token, {
      refreshToken: refreshToken,
      sessionId: sessionId,
    });

    console.log("🔍 Refresh token response:", res.data);

    if (res && res.status === 200) {
      const responseData = res.data;

      // ✅ Handle nested structure
      if (responseData.success && responseData.data) {
        const {
          token,
          refreshToken: newRefreshToken,
          sessionId: updatedSessionId,
        } = responseData.data;

        store.dispatch(loginUser(responseData?.data));

        // Update tokens in localStorage
        if (token) {
          localStorage.setItem("accessToken", token);
        }
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }
        // SessionId should remain the same, but update if provided
        if (updatedSessionId) {
          localStorage.setItem("sessionId", updatedSessionId);
        }

        return responseData.data;
      } else {
        throw new Error("Invalid response structure");
      }
    } else {
      throw new Error("Auth credential validation failed.");
    }
  } catch (err) {
    return handleError(err);
  }
};

export const fetchLinkedToken = async () => {
  try {
    const res = await axios.get(api.linkedToken);
    if (res && res.status === 200) {
      return res.data;
    } else {
      throw new Error("Auth credential validation failed.");
    }
  } catch (err) {
    return handleError(err);
  }
};

export const resetPassword = async (id) => {
  try {
    const { data } = await axios.post(api.resetPassword, { id });
    return data && data.success ? true : false;
  } catch (err) {
    return handleError(err);
  }
};

export const generateUserNames = async (firstName, lastName) => {
  try {
    const { data } = await axios.get(api.generateUserNames, {
      params: {
        firstName,
        lastName,
      },
    });

    return data;
  } catch (err) {
    return handleError(err);
  }
};

export const updateUserName = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateUserName, payload);
    return data && data.success ? true : false;
  } catch (err) {
    return handleError(err);
  }
};

export const updateUserProfile = async (payload) => {
  try {
    const { data } = await axios.patch(api.updateUserProfile, payload);
    return data;
  } catch (err) {
    return handleError(err);
  }
};
